import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]
  static classes = ["secondaryRow", "exclude"]

  connect() {
    this.rafId = null
    this.observer = new ResizeObserver(() => {
      if (this.rafId) cancelAnimationFrame(this.rafId)
      this.rafId = requestAnimationFrame(() => {
        this.rafId = null
        this.check()
      })
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.rafId) cancelAnimationFrame(this.rafId)
    this.observer.disconnect()
  }

  rowTargetConnected() {
    this.check()
  }

  rowTargetDisconnected() {
    this.check()
  }

  check() {
    const visibleRows = this.rowTargets.filter(row => row.offsetParent !== null)
    if (visibleRows.length === 0) return

    const visibleChildren = Array.from(visibleRows[0].children).filter(el =>
      !el.classList.contains("hidden") && !el.classList.contains(this.excludeClass) &&
      window.getComputedStyle(el).display !== "none"
    )

    const isSingleLine = visibleChildren.length < 2 ||
      !visibleChildren.some(el => el.offsetTop > visibleChildren[0].offsetTop)

    visibleRows.forEach((row, index) => {
      row.classList.toggle(this.secondaryRowClass, isSingleLine && index > 0)
    })
  }
}
